var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXzc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#23B852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5328 10.7708H12.4397V12.438H6.71062L13.8223 5.32127C13.9351 5.20714 14.0122 5.06262 14.0441 4.90538C14.0761 4.74815 14.0616 4.585 14.0023 4.43589C13.9394 4.28769 13.8342 4.16135 13.6998 4.0727C13.5654 3.98404 13.4079 3.93702 13.2469 3.93752H4.75312C4.64571 3.93677 4.53922 3.95739 4.43985 3.99819C4.34048 4.03898 4.25022 4.09913 4.17432 4.17514C4.09842 4.25115 4.03839 4.34149 3.99773 4.44091C3.95708 4.54034 3.9366 4.64686 3.9375 4.75427V10.7708L7.46719 7.23827H5.56031V5.56202H11.2798L4.17769 12.6788C4.06491 12.7929 3.98782 12.9374 3.95586 13.0947C3.92389 13.2519 3.93842 13.415 3.99769 13.5641C4.1265 13.8651 4.41844 14.0625 4.75312 14.0625H13.2469C13.3541 14.0625 13.4602 14.0414 13.5593 14.0003C13.6583 13.9593 13.7483 13.8991 13.824 13.8232C13.8998 13.7474 13.9598 13.6573 14.0007 13.5582C14.0417 13.4592 14.0626 13.353 14.0625 13.2458V7.23827L10.5328 10.7708Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXzc);
export default __webpack_public_path__ + "static/media/xzc.f15b4af7b68f0686919e380ed5e5fa3b.svg";
export { ForwardRef as ReactComponent };